import Constant from '@/constant';
import teleAPI from '@/api/tele';

export default {
    [Constant.AUTH_INAPP]: (store, payload) => {
        return new Promise((resolve, reject) => {
            teleAPI.authInapp(payload.type, payload.id, payload.ref)
                .then((response) => {
                    console.log(JSON.stringify(response.data.redirectUrl));
                    resolve(response.data.redirectUrl)
                })
                .catch((err) => {
                    console.log(JSON.stringify(err.response));
                })
        })
    },
    [Constant.FETCH_USER_VISIT_INFOS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            teleAPI.fetchUserVisitInfos(payload.uuid)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((err) => {
                    console.log(JSON.stringify(err.response));
                })
        })
    },
    [Constant.FETCH_SHORT_URL]: (store, payload) => {
        return new Promise((resolve, reject) => {
            teleAPI.fetchShortUrl(payload.key)
                .then((response) => {
                    resolve(response.data.mobileLink)
                })
                .catch((err) => {
                    console.log(JSON.stringify(err.response));
                })
        })
    },
    [Constant.FETCH_HOSPITAL_INFOS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            teleAPI.fetchHospitalInfos(payload.uuid)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((err) => {
                    console.log(JSON.stringify(err.response));
                })
        })
    },
    [Constant.SEND_EVENT_CODE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            teleAPI.sendEventCode(payload.eventName, payload.eventCode, payload.time)
                .then((response) => {
                    resolve()
                })
                .catch((err) => {
                    console.log(JSON.stringify(err.response));
                })
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js